import React, {FC, Fragment, useState} from "react";
import cls from "./category.module.scss";
import InputRange, {Range} from "react-input-range";
import {ICurrencies} from "../Wrappers/MainLayout";
import {useRouter} from "next/router";

interface IFilterRangeProps {
    data: { min: number, max: number };
    title: string,
    selectedRate: ICurrencies
}

const CustomFilterRange: FC<IFilterRangeProps> = (
    {
        data: {min, max} = {min: 0, max: 0},
        title,
        selectedRate: {symbol: selectedCurrSymbol = ""} = {}
    }
) => {
    const { query: { filter_price = `${min},${max}`, ...otherQuery }, push: routerPush } = useRouter();
    const priceRange = String(filter_price)?.split(",").map(Number)
    const [[stateFrom, stateTo], setState] = useState<number[]>(priceRange);
    const handleChange = ({min: newFrom, max: newTo}: Range) => {
        setState([newFrom, newTo]);
    }
    const handleCompleteChange = async ({min: newFrom, max: newTo}: Range) => {
        await routerPush({query: {...otherQuery, filter_price: `${newFrom},${newTo}`}}, {}, {scroll: false})
    }

    return (
        <div className={cls["filter-price"]}>
            <div className={cls.widget__title}>{title}</div>
            {max ? (
                <Fragment>
                    <div className={cls["filter-price__title"]}>
                    <span
                        className={cls["filter-price__min-value"]}>{stateFrom}{selectedCurrSymbol}</span>
                        <span className={cls["filter-price__max-value"]}>{stateTo}{selectedCurrSymbol}</span>
                    </div>
                    <div className={`${cls["filter-price__slider"]} ${min === max ? cls.same_min_max : ""}`} dir="ltr">
                        <InputRange
                            minValue={min}
                            maxValue={max}
                            value={{min: stateFrom, max: stateTo}}
                            step={1}
                            onChange={handleChange as (value: Range | number) => void}
                            onChangeComplete={handleCompleteChange as (value: Range | number) => void}
                        />
                    </div>
                </Fragment>
            ) : <Fragment />}
        </div>
    )
}

export default CustomFilterRange;
